module.exports = __webpack_public_path__ + "static/img/iconLauraMoon.bbd5129.svg";


//////////////////
// WEBPACK FOOTER
// ./static/svg/iconLauraMoon.svg
// module id = FGdL
// module chunks = 1